<template>
  <div>
    <q-tabs :value="tab" @input="changeTab" dense align="justify" class="tab" narrow-indicator>
      <q-tab v-if="indicadoresCualitativos.length > 0" name="cualitativos" label="Indicadores cualitativos"></q-tab>
      <q-tab v-if="indicadoresCuantitativos.length > 0" name="cuantitativos" label="Indicadores cuantitativos"></q-tab>
      <q-tab v-if="indicadoresSatelitales.length > 0" name="otros" label="Otros indicadores"></q-tab>
    </q-tabs>

    <q-separator class="separator"></q-separator>

    <q-tab-panels :value="tab" @input="changeTab" animated>
      <q-tab-panel name="cualitativos">
        <a
          href="https://cdn.mitma.gob.es/portal-web-drupal/AUE/04_doc._indicadores_de_seguimiento_y_evaluacion_0.pdf"
          target="_blank"
        >
          <div class="divLink">
            Mas información sobre indicadores
            <q-icon
              style="font-size: 1em; margin-left:5px"
              name="launch"
            ></q-icon>
          </div>
        </a>
        <div>
          <q-list
            v-for="indicadorCualit in indicadoresCualitativos"
            :key="indicadorCualit.id"
            bordered
            class="rounded-borders"
          >
            <!--<q-item-section class="sectionCheck" avatar top>
              <q-checkbox
                @input="toExpand(indicadorCualit)"
                v-model="indicadorCualit.seleccionado"
                :id="indicadorCualit.id"
                color="primary"
              />
            </q-item-section>-->
            <q-expansion-item
              group="somegroup"
              expand-separator
              :label="indicadorCualit.name"
              v-model="indicadorCualit.expand"
              :id="indicadorCualit.id"
              @before-show="indicadorCualit.expand ? checkChanges(indicadorCualit, false) : null"
              @input="!indicadorCualit.expand ? checkChanges(indicadorCualit, true) : null"
            >
            <template v-slot:header>
              <q-item-section>
                <span v-if="indicadorCualit.isManual">Indicador propio: {{indicadorCualit.name}}</span>
                <span v-else>Indicador AUE: {{indicadorCualit.name}}</span>
              </q-item-section>
              <q-item-section side><q-chip class="chipAcciones" outline>{{indicadorCualit.numeroAcciones}} acciones</q-chip></q-item-section>
            </template>
              <q-card>
                <q-card-section>
                  <!--detalle indicador cualitativo-->
                  <div class="row">
                    <div class="col-1">
                      <q-select
                        v-if="optionSelected"
                        class="input"
                        outlined
                        :options="optionsSelect ? optionsSelect : ['No hay opciones']"
                        option-value="id"
                        option-label="name"
                        v-model="optionSelected"
                        :loading="isLoadingCombo"
                        :disable="disableCombo || isOnlyAccess"
                        @input="changeDirtyForm()"
                      >
                      </q-select>
                    </div>
                  </div>
                  <div v-if="indicadorCualit.expand" class="row divStepper">
                    <StepperIndicador
                      v-if="indicadorCualit.isManual || indicadorCualit.subtipo === subtipo_defecto || ((indicadorCualit.subtipo ===subtipo_declaracion || indicadorCualit.subtipo === subtipo_libre) && optionSelected.name===respuesta_negativa)"
                      :dataIndicador="dataIndicador"
                      :isLoading="isLoading"
                      :optionSelected ="optionSelected"
                      :isManual="indicadorCualit.isManual"
                      @updateCancel="cancel(indicadorCualit)"
                      @updateStep ="updateOption"
                      @updatePlanes="updatePlanes"
                      @updateIndicadores = "updateIndicadores"
                      tipoIndicador="cualitativo"
                    />

                    <!-- subtipo libre-->
                    <div class="divTipoLibre" v-if="(indicadorCualit.subtipo === subtipo_libre || indicadorCualit.subtipo ===subtipo_declaracion) && optionSelected.name===respuesta_afirmativa">
                      <Planificacion
                        :subtipo="indicadorCualit.subtipo"
                        :instrumentoPlan="dataIndicadorInstrumentoPlan"
                        :isLoading="isLoading"
                        :optionSelected ="optionSelected"
                        @updateDataIndicador="fillDataIndicador"
                        @updateArrayFiles="fillArrayFiles"
                      />

                      <q-btn
                        @click="saveDataIndicador(indicadorCualit.subtipo, indicadorCualit)"
                        class="bPrincipal saveLibre"
                        :disabled="checkDisabled(indicadorCualit.subtipo) || isLoadingSave"
                        label="Guardar"
                        :loading="isLoadingSave"
                        :style="isOnlyAccess?'display: none': ''"
                      ></q-btn>
                    </div>

                  </div>
                </q-card-section>
              </q-card>
            </q-expansion-item>
          </q-list>
        </div>
      </q-tab-panel>

      <q-tab-panel name="cuantitativos">
        <a
          href="https://cdn.mitma.gob.es/portal-web-drupal/AUE/04_doc._indicadores_de_seguimiento_y_evaluacion_0.pdf"
          target="_blank"
        >
          <div class="divLink">
            Mas información sobre indicadores
            <q-icon
              style="font-size: 1em; margin-left:5px"
              name="launch"
            ></q-icon>
          </div>
        </a>
        <div>
          <q-list
            v-for="indicadorCuantit in indicadoresCuantitativos"
            :key="indicadorCuantit.id"
            bordered
            class="rounded-borders"
          >
            <!--<q-item-section class="sectionCheck" avatar top>
              <q-checkbox
                @input="toExpand(indicadorCuantit)"
                v-model="indicadorCuantit.seleccionado"
                :id="indicadorCuantit.id"
                color="primary"
              />
            </q-item-section>-->
            <q-expansion-item
              group="somegroup"
              expand-separator
              :label="indicadorCuantit.name"
              v-model="indicadorCuantit.expand"
              :id="indicadorCuantit.id"
              @before-show="indicadorCuantit.expand ? checkChanges(indicadorCuantit, false) : null"
              @input="!indicadorCuantit.expand ? checkChanges(indicadorCuantit, true) : null"
            >
            <template v-slot:header>
              <q-item-section>
                <span v-if="indicadorCuantit.isManual">Indicador propio: {{indicadorCuantit.name}}</span>
                <span v-else>Indicador AUE: {{indicadorCuantit.name}}</span>
              </q-item-section>
              <q-item-section side><q-chip class="chipAcciones" outline>{{indicadorCuantit.numeroAcciones}} acciones</q-chip></q-item-section>
            </template>
              <q-card>
                  <q-card-section>
                  <!--detalle indicador cuantitativo-->
                  <div v-if="indicadorCuantit.expand" class="row divStepper">
                    <StepperIndicador
                      :dataIndicador="dataIndicador"
                      :isLoading="isLoading"
                      :isManual="indicadorCuantit.isManual"
                      @updateCancel="cancel(indicadorCuantit)"
                      @updateIndicadores = "updateIndicadores"
                      tipoIndicador="cuantitativo"
                    />
                  </div>
                </q-card-section>
              </q-card>
            </q-expansion-item>
          </q-list>
        </div>
      </q-tab-panel>

      <q-tab-panel name="otros">
        <div>
          <q-list
            v-for="indicadorSatelital in indicadoresSatelitales"
            :key="indicadorSatelital.id"
            bordered
            class="rounded-borders"
          >
            <!--<q-item-section class="sectionCheck" avatar top>
              <q-checkbox
                @input="toExpand(indicadorSatelital)"
                v-model="indicadorSatelital.seleccionado"
                :id="indicadorSatelital.id"
                color="primary"
              />
            </q-item-section>-->
            <q-expansion-item
              group="somegroup"
              expand-separator
              :label="indicadorSatelital.name"
              v-model="indicadorSatelital.expand"
              :id="indicadorSatelital.id"
              @before-show="indicadorSatelital.expand ? checkChanges(indicadorSatelital, false) : null"
              @input="!indicadorSatelital.expand ? checkChanges(indicadorSatelital, true) : null"
            >
            <template v-slot:header>
              <q-item-section>
                  {{indicadorSatelital.name}}
              </q-item-section>
              <q-item-section side><q-chip class="chipAcciones" outline>{{indicadorSatelital.numeroAcciones}} acciones</q-chip></q-item-section>
            </template>
              <q-card>
                  <q-card-section>
                  <!--detalle indicador satelital-->
                  <div v-if="indicadorSatelital.expand" class="row divStepper">
                    <StepperIndicador
                      :dataIndicador="dataIndicadorGrafica"
                      :dataIndicadorGrafica ="dataIndicadorGrafica.tarjeta"
                      :isLoading="isLoading"
                      @updateCancel="cancel(indicadorSatelital)"
                      @updateListadoSatelitales="updateListadoSatelitales"
                      tipoIndicador="satelital"
                    />
                  </div>
                </q-card-section>
              </q-card>
            </q-expansion-item>
          </q-list>
        </div>
      </q-tab-panel>
    </q-tab-panels>
    <DialogWarning
        v-model="showDialog"
        dataCy="delete-indicador"
        :showIcon="true"
        :txtContainer="
          `Los datos introducidos no han sido guardados. Si abandona el proceso sin guardar se perderán todos los cambios.¿Desea salir del indicador?`
        "
        labelDelete="SÍ, SALIR Y PERDER TODOS LOS CAMBIOS"
        labelCancel="NO, PERMANECER EN EL INDICADOR"
        @save="saveChanges()"
      />
  </div>
</template>
<script>
import { QTabPanel, QTab, QTabs, QTabPanels } from 'quasar';
import Vue from 'vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import StepperIndicador from '@/components/PlanAccion/components/StepperIndicador.vue';
import { mapGetters } from 'vuex';
import Planificacion from '@/components/PlanAccion/components/Planificacion.vue';
import Const from '@/components/shared/helpers/Const.js';
import DialogWarning from '@/shared/dialogs/warning/DialogWarning.vue';

export default {
  components: {
    QTabPanel,
    QTab,
    QTabs,
    QTabPanels,
    StepperIndicador,
    Planificacion,
    DialogWarning
  },
  props: {
    idObjetivoSelected: String,
    idObjetivoEstategico: String,
    form_dirty: Boolean
  },
  mixins: [Loading],
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      objetivoEspecifico: 'NGUD/objetivoEspecifico',
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  data () {
    return {
      tab: 'cualitativos',
      activeTab: 'cualitativos',
      indicadoresCualitativos: [],
      indicadoresCuantitativos: [],
      indicadoresSatelitales: [],
      subtipo_defecto: Const.SUBTIPO_DEFECTO,
      subtipo_libre: Const.SUBTIPO_LIBRE,
      subtipo_declaracion: Const.SUBTIPO_SUBIR_DECLARACION,
      respuesta_afirmativa: Const.RESPUESTA_AFIRMATIVA,
      respuesta_negativa: Const.RESPUESTA_NEGATIVA,
      optionsSelect: [{ name: 'Sí', id: 1 }, { name: 'No', id: 2 }],
      optionSelected: { name: 'Sí', id: 1 },
      idObjetivosEstrategicoSelected: '',
      isLoading: false,
      dataIndicador: {},
      disableCombo: false,
      isLoadingCombo: true,
      dataIndicadorGrafica: {},
      dataIndicadorInstrumentoPlan: {},
      isLoadingSave: false,
      arrayFiles: [],
      showDialog: false,
      flagIndicador: false,
      indicadorSelected: null,
      show: null
    };
  },
  async created () {
    this.getIndicadores();
    this.getIndicadoresSatelitales();
  },
  mounted () {
    this.$eventHub.$on('deleteFile', (fileToDelete) => {
      let pos = 0;
      this.arrayFiles.forEach(file => {
        if (file.name === fileToDelete.nombre) {
          this.arrayFiles.splice(pos, 1);
        }
        pos++;
      });
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('deleteFile');
  },
  watch: {
    idObjetivoSelected () {
      this.getIndicadores();
      this.getIndicadoresSatelitales();
    },
    idObjetivoEstategico () {
      this.idObjetivosEstrategicoSelected = this.idObjetivoEstategico;
    }
  },
  methods: {
    fillData () {
      if (this.dataIndicador) {
        this.dataIndicadorInstrumentoPlan = this.dataIndicador.instrumentoPlanIndicadorAUE;
      }
    },
    fillDataIndicador (dataIndicador) {
      this.dataIndicadorInstrumentoPlan = dataIndicador;
      this.$eventHub.$emit('dirtyForm');
    },
    fillArrayFiles (fileToAdd) {
      this.arrayFiles.push(fileToAdd);
      this.checkDisabled(this.subtipo_declaracion);
      this.$eventHub.$emit('dirtyForm');
    },
    async saveDataIndicador (subtipo, indicador) {
      this.isLoadingSave = true;
      if (subtipo === this.subtipo_declaracion && this.optionSelected.name === Const.RESPUESTA_AFIRMATIVA) {
        let arrayIdsFiles = [];
        if (this.arrayFiles.length > 0) {
          arrayIdsFiles = await this.saveFiles();
        }
        // hacer el post del indicador
        // listado actual
        let listadoActual = [];
        this.dataIndicadorInstrumentoPlan.listadoDeDeclaraciones.forEach(item => {
          if (item.id !== undefined) listadoActual.push({ id: item.id });
        });

        this.dataIndicadorInstrumentoPlan.listadoDeDeclaraciones = listadoActual;
        // listado de nuevos añadidos
        if (arrayIdsFiles.length > 0) {
          arrayIdsFiles.forEach(fileSaved => {
            this.dataIndicadorInstrumentoPlan.listadoDeDeclaraciones.push({ id: fileSaved });
          });
        }
        this.arrayFiles = [];
        this.save(indicador);
      } else {
        this.save();
      }
    },
    async saveFiles () {
      let arrayPromesas = [];

      this.arrayFiles.forEach(async file => {
        arrayPromesas.push(this.$store.dispatch(types.ACTION_SAVE_INDICADOR_DOCUMENTOPDF, {
          file: { Documento: file }
        }));
      });
      const value = Promise.all(arrayPromesas);
      return value;
    },
    save (indicador) {
      this.dataIndicadorInstrumentoPlan.planes = [];

      let dataIndicador = {
        idCiudad: this.dataIndicador.idCiudad,
        idIndicadorAUE: this.dataIndicador.idIndicadorAUE,
        idObjetivoEspecifico: this.objetivoEspecifico.id,
        instrumentoPlanIndicadorAUE: this.dataIndicadorInstrumentoPlan,
        respuesta: this.optionSelected !== undefined && this.optionSelected.name !== Const.RESPUESTA_NEGATIVA
      };

      this.$store
        .dispatch(types.ACTION_SAVE_INDICADORAUE, {
          idCiudad: this.ciudadSelected.id,
          dataIndicador: dataIndicador
        })
        .then((response) => {
          this.isLoadingSave = false;
          this.$eventHub.$emit('cleanForm');
          if (indicador !== undefined) this.getDataIndicador(indicador);
          this.getIndicadores();
          this.getIndicadoresSatelitales();
        })
        .catch(() => {
          this.isLoadingSave = false;
        });
    },
    toExpand (indicador) {
      if (indicador.seleccionado) {
        Vue.set(indicador, 'expand', true);
        if (indicador.tipo === 'Cualitativo') {
          this.getDataIndicador(indicador);
        }
      } else {
        Vue.set(indicador, 'expand', false);
      }
    },
    cancel (indicador) {
      if (indicador.seleccionado) {
        Vue.set(indicador, 'seleccionado', false);
      }
      Vue.set(indicador, 'expand', false);
    },
    updateOption (step) {
      this.disableCombo = step > 1;
    },
    getIndicadores () {
      this.indicadoresCualitativos = [];
      this.indicadoresCuantitativos = [];
      this.showLoading();
      this.$store
        .dispatch(types.ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO, {
          idObjetivoEspecifico: this.idObjetivoSelected,
          idCiudad: this.ciudadSelected.id
        })
        .then(response => {
          this.hideLoading();
          this.prepareDataIndicadores(response);
        })
        .catch(() => {
          this.hideLoading();
        });
    },
    getIndicadoresSatelitales () {
      this.indicadoresSatelitales = [];
      this.showLoading();
      this.$store.dispatch(types.ACTION_GET_INDICADORSATELITAL_OBJETIVOESPECIFICO, {
        idObjetivoEspecifico: this.idObjetivoSelected,
        idCiudad: this.ciudadSelected.id
      }).then(response => {
        this.hideLoading();
        this.prepareDataIndicadores(response);
      }).catch(() => {
        this.hideLoading();
      });
    },
    prepareDataIndicadores (indicadores) {
      indicadores.forEach(indicador => {
        indicador['expand'] = false;
        if (indicador.tipo === 'Cualitativo') {
          this.indicadoresCualitativos.push(indicador);
        } else if (indicador.tipo === 'Cuantitativo') {
          this.indicadoresCuantitativos.push(indicador);
        } else {
          this.indicadoresSatelitales.push(indicador);
        }
      });
    },
    async getDataIndicadorSatelital (IndicadorSelected) {
      if (IndicadorSelected.expand === true) {
        if (IndicadorSelected.name !== undefined) this.$store.commit('NGUD/setNameIndicador', IndicadorSelected.name);
        this.showLoading();
        await this.$store.dispatch(types.ACTION_GET_INDICADOR_SATELITAL, {
          idCiudad: this.ciudadSelected.id,
          idIndicador: IndicadorSelected.id,
          id: IndicadorSelected.idRelacion
        }).then(response => {
          this.dataIndicadorGrafica = response.data;
          this.hideLoading();
        }).catch(() => {
          this.hideLoading();
        });
      }
    },
    checkChanges (IndicadorSelected, show) {
      this.flagIndicador = true;
      if (this.form_dirty) {
        Vue.set(IndicadorSelected, 'expand', show);
        this.show = !show;
        this.indicadorSelected = IndicadorSelected;
        this.showDialog = true;
      } else {
        if (IndicadorSelected.hasOwnProperty('tipo') && (IndicadorSelected.tipo === 'Cualitativo' || IndicadorSelected.tipo === 'Cuantitativo')) {
          this.getDataIndicador(IndicadorSelected);
        } else this.getDataIndicadorSatelital(IndicadorSelected);
      }
    },
    getDataIndicador (IndicadorSelected) {
      this.arrayFiles = [];
      // esto es para limpiar el combo mientras se rellena
      this.optionSelected = { name: '', id: 3 };
      this.isLoadingCombo = true;
      this.disableCombo = false;
      if (IndicadorSelected.expand === true) {
        if (IndicadorSelected.name !== undefined) this.$store.commit('NGUD/setNameIndicador', IndicadorSelected.name);
        this.showLoading();
        this.isLoading = true;

        let aue = {
          idIndicadorAUE: IndicadorSelected.id,
          idCiudad: this.ciudadSelected.id,
          isManual: IndicadorSelected.isManual
        };

        this.$store
          .dispatch(types.ACTION_GET_DATA_INDICADORAUE, aue)
          .then(response => {
            this.dataIndicador = response.data;
            if (this.dataIndicador.respuesta === true) {
              this.optionSelected = { name: 'Sí', id: 1 };
            } else {
              this.optionSelected = { name: 'No', id: 2 };
            }
            this.hideLoading();
            this.fillData();
            this.isLoading = false;
            this.isLoadingCombo = false;
          })
          .catch(() => {
            this.hideLoading();
            this.isLoading = false;
          });
      }
    },
    updateListadoSatelitales (object) {
      // modifica array de indicadores satelitales
      if (this.indicadoresSatelitales.length > 0) {
        this.indicadoresSatelitales.forEach(indicador => {
          if (indicador.id === object.id) {
            Vue.set(indicador, 'idRelacion', object.idRelacion);
          }
        });
      }
      object['expand'] = true;
      this.getDataIndicadorSatelital(object);
      this.getIndicadoresSatelitales();
    },
    checkDisabled (subtipo) {
      if (this.optionSelected.name === Const.RESPUESTA_AFIRMATIVA) {
        if (subtipo !== this.subtipo_declaracion) {
          return false;
        } else {
          return (this.arrayFiles.length === 0) && (this.dataIndicadorInstrumentoPlan.listadoDeDeclaraciones !== undefined && this.dataIndicadorInstrumentoPlan.listadoDeDeclaraciones.length === 0);
        }
      } else {
        return !(this.dataIndicadorInstrumentoPlan.compromisos !== null && this.dataIndicadorInstrumentoPlan.compromisos !== '');
      }
    },
    updatePlanes (indicador) {
      this.getDataIndicador(indicador);
    },
    updateIndicadores () {
      this.getIndicadores();
    },

    closeDialog () {
      if (!this.flagIndicador) this.changeActiveTab(this.activeTab);
      this.showDialog = false;
    },
    saveChanges () {
      this.showDialog = false;
      if (!this.flagIndicador) {
        this.changeActiveTab(this.activeTab);
        this.changeDataTab();
      } else {
        Vue.set(this.indicadorSelected, 'expand', this.show);
        this.$eventHub.$emit('cleanForm');
        this.$emit('updateDirtyForm');
        if (this.indicadorSelected.hasOwnProperty('tipo') && (this.indicadorSelected.tipo === 'Cualitativo' || this.indicadorSelected.tipo === 'Cuantitativo')) this.getDataIndicador(this.indicadorSelected);
        else this.getDataIndicadorSatelital(this.indicadorSelected);
      }
    },
    changeDataTab () {
      this.$eventHub.$emit('cleanForm');
      this.$emit('updateDirtyForm');
      if (this.indicadoresCualitativos.length > 0) {
        this.indicadoresCualitativos.forEach(indicador => {
          Vue.set(indicador, 'expand', false);
        });
      }
      if (this.indicadoresCuantitativos.length > 0) {
        this.indicadoresCuantitativos.forEach(indicador => {
          Vue.set(indicador, 'expand', false);
        });
      }
      if (this.indicadoresSatelitales.length > 0) {
        this.indicadoresSatelitales.forEach(indicador => {
          Vue.set(indicador, 'expand', false);
        });
      }
    },
    changeActiveTab (val) {
      this.tab = val;
      this.activeTab = val;
    },
    changeTab (val) {
      this.flagIndicador = false;
      if (this.form_dirty) {
        this.activeTab = val;
        this.showDialog = true;
      } else {
        this.changeActiveTab(val);
        this.changeDataTab();
      }
    },
    changeDirtyForm () {
      this.$eventHub.$emit('dirtyForm');
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  div.tab {
    margin-top: 15px;
  }
  .q-separator {
    height: 0px !important;
  }
  .separator {
    height: 4px !important;
    background: #e9f4f6 !important;
  }
  div.q-tab__indicator.q-tab__indicator {
    color: #67d2df !important;
    height: 3px;
  }
  div.q-tab__label {
    color: #002f6c;
    text-transform: capitalize !important;
    font-weight: bold;
  }
  div.q-tab__label,
  .divLink {
    font-family: DINPro;
    font-size: 17px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.68px;
  }
  .divLink {
    font-weight: 500;
    color: #565656;
    margin-bottom: 20px;
    margin-top: 15px;
  }
  a {
    text-decoration: none;
  }
  .q-expansion-item {
    // width: calc(100% - 56px);
    width: 100%;
  }
  .q-expansion-item:hover {
    background-color: rgba(253, 249, 249, 0.295);
  }
  .q-list {
    display: flex;
    margin-bottom: 20px;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
      0 2px 1px -1px rgba(0, 0, 0, 0.12);
  }
  .q-item__section {
    font-family: DINPro;
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.13px;
    color: #555;
  }
  .chipAcciones{
    border-radius: 16px;
    background-color: #d8d8d8 !important;
    border-color: #d8d8d8 !important;
    .q-chip__content{
      padding-bottom: 2px;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.2px;
      color: #565656;
    }
  }
  .sectionCheck {
    margin-top: 3px;
    padding-right: 0px;
    align-content: center;
  }
  .divTipoLibre{
    width: 100%;
  }
  .saveLibre{
    float: right;
    margin-top: 24px;
  }
}
</style>
